<template>
  <div class="d-flex flex-column align-center justify-center" style="gap: 24px; width: 100%;">
    <div class="shop-container">
      <div class="d-flex align-center justify-space-between mb-3">
        <Logo />
        <div class="d-flex align-center" style="gap: 8px;">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon @click="$router.push({ name: 'report' })" class="report-btn">
                <v-icon color="primary">mdi-chart-bar</v-icon>
              </v-btn>
            </template>
            <span>Revenue Report</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon @click="$router.push({ name: 'report-catalog' })" class="report-btn">
                <v-icon color="primary">mdi-package-variant-closed</v-icon>
              </v-btn>
            </template>
            <span>Catalog Report</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click="$router.push({ name: 'content-library' })"
                class="report-btn"
              >
                <v-icon color="primary">mdi-bookshelf</v-icon>
              </v-btn>
            </template>
            <span>Content Library</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon @click="$router.push({ name: 'report-ads' })" class="report-btn">
                <v-icon color="primary">mdi-bullhorn-outline</v-icon>
              </v-btn>
            </template>
            <span>Ads Report</span>
          </v-tooltip>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-badge bordered top color="success" dot offset-x="11" offset-y="11">
              <v-avatar v-on="on" :size="40" class="pointer">
                <v-img
                  v-if="user && user.profilePicture"
                  :src="imageHelpers.url(user.profilePicture)"
                  :alt="fullName"
                />
                <v-img v-else src="/admin/img/avatar.png" />
              </v-avatar>
            </v-badge>
          </template>
          <v-card class="pa-1" width="200px" flat>
            <div v-if="user" class="pa-2" style="gap: 12px;border-bottom: solid 1px var(--v-border-base);">
              <h4 class="primary--text">{{ fullName }}</h4>
              <p class="mb-0" style="font-size: 14px; opacity: 0.8;">{{ user.email }}</p>
            </div>
            <v-list class="pb-0 pt-1" dense>
              <v-list-item @click="$router.push({ name: 'account-profile' })" class="rounded-lg px-2" link>
                <Icon icon="heroicons:user-circle" width="24px" height="24px" class="primary--text" />
                <v-list-item-title class="pl-2 primary--text font-weight-medium">Profile</v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout" color="error" class="rounded-lg px-2" link>
                <Icon icon="heroicons:arrow-right-on-rectangle" width="24px" height="24px" class="error--text" />
                <v-list-item-title class="pl-2 error--text font-weight-medium">Sign out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <!-- Add a new shop -->
      <v-text-field
        v-model="searchText"
        prepend-inner-icon="mdi-magnify pointer"
        placeholder="Search stores"
        hide-details="auto"
        color="primary"
        background-color="white"
      ></v-text-field>
      <div v-if="isLoading" class="mt-2">
        <v-skeleton-loader class="mb-2" type="list-item-avatar-three-line"></v-skeleton-loader>
        <v-skeleton-loader class="mb-2" type="list-item-avatar-three-line"></v-skeleton-loader>
        <v-skeleton-loader class="mb-2" type="list-item-avatar-three-line"></v-skeleton-loader>
        <v-skeleton-loader class="mb-2" type="list-item-avatar-three-line"></v-skeleton-loader>
        <v-skeleton-loader class="mb-2" type="list-item-avatar-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-avatar-three-line"></v-skeleton-loader>
      </div>
      <v-list v-else class="mt-2 no-scrollbar" color="transparent" style="max-height: 70dvh; overflow-y: auto;">
        <v-list-item
          v-for="(store, index) in storesDisplay"
          :key="index"
          class="pr-2 mb-2 rounded-lg white"
          :class="{ 'disabled-store': !store.isEnabled }"
          @click="onClickShop(store)"
        >
          <div class="store-image">
            <v-img src="/admin/img/store.png" />
          </div>
          <v-list-item-content class="ml-4">
            <v-list-item-title class="font-weight-medium primary--text">{{ store.storeDetail.name }}</v-list-item-title>
            <v-list-item-subtitle v-if="store.isEnabled"
              >{{ store.storeDetail.defaultSystemDomain }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="store.isEnabled">
            <i class="ri-arrow-right-circle-line grey--text ri-lg"></i>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-btn
        v-if="!isLoading"
        color="primary"
        @click="showCreateDialog = true"
        :height="36"
        class="mt-4"
        block
        depressed
        ><v-icon left>mdi-plus</v-icon> New store</v-btn
      >
    </div>
    <v-dialog v-model="showCreateDialog" :width="400">
      <v-card class="pa-4">
        <h3 class="primary--text">New store</h3>
        <v-text-field
          v-model="store.name"
          :error-messages="
            invalid && !$v.store.name.required
              ? $t('Store name is required')
              : invalid && !$v.store.name.minLength
              ? $t('Store name must have at least ' + $v.store.name.$params.minLength.min + ' letters.')
              : invalid && !$v.store.name.maxLength
              ? $t('Store name must have at least ' + $v.store.name.$params.maxLength.max + ' letters.')
              : invalid && !$v.store.name.alpha
              ? $t('Store name cannot contain special characters')
              : error
              ? $t(error)
              : ''
          "
          placeholder="Enter store name"
          color="primary"
          hidden-details="auto"
        ></v-text-field>
        <div class="text-end mt-2">
          <v-btn class="mr-2" text outlined @click="showCreateDialog = false">Cancel</v-btn>
          <v-btn :loading="isLoadingButton" color="primary" depressed @click="addStore">Create</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { authService } from '@/apis/auth.s';
import { userService } from '@/apis/user.s';
import { storeService } from '@/apis/store.s';
import STORAGE_NAME from '@/const/storage';
import { mapGetters, mapMutations } from 'vuex';
import { required, minLength, maxLength, helpers } from 'vuelidate/lib/validators';
const alpha = helpers.regex('alpha', /^[a-zA-Z0-9]*$/);
import verifyMixin from '@/mixins/verify';
import { widgetApi } from '@/apis/widget';
import Logo from './Logo';
import imageHelpers from '@/helpers/image';
import { Icon } from '@iconify/vue2';

export default {
  components: {
    Logo,
    Icon,
  },
  mixins: [verifyMixin],
  validations: {
    store: {
      name: {
        required,
        alpha,
        minLength: minLength(4),
        maxLength: maxLength(50),
      },
    },
  },
  data() {
    let defaultConfig = {
      // loading: false,
      activated: false,
      device: 'desktop',
      widgetType: 'bestSeller',
      widgetCustomize: {
        productPrice: {
          align: 'center',
          bold: false,
          fontColor: '#000000',
          fontSize: '14px',
          italic: false,
          underline: false,
          textTitle: 'Title ',
        },
        productName: {
          align: 'center',
          bold: false,
          fontColor: '#000000',
          fontSize: '14px',
          italic: false,
          underline: false,
          textTitle: 'Programmer Label Personalized',
        },
        place: {
          cartPage: false,
          categoryPage: false,
          homePage: false,
          productPage: true,
          page: {
            collectionIds: [],
            productIds: [],
            selectType: 'products',
            isShowAtSpecificPage: false,
          },
        },
        header: {
          align: 'center',
          bold: false,
          fontColor: '#000000',
          fontSize: '25px',
          italic: false,
          underline: false,
          textTitle: 'Handpicked products just for you',
        },

        addCartButton: {
          enabled: true,
          callToAction: {
            align: 'center',
            bold: false,
            fontColor: '#000000',
            fontSize: '12px',
            italic: false,
            underline: false,
            textTitle: 'Title ',
          },
        },
        layout: '1',
        numberOfProducts: {
          productsPerSlide: 6,
          productsToBeShown: 12,
        },
      },
    };
    return {
      defaultConfig,
      type: 'password',
      isLoading: true,
      isLoadingButton: false,
      stores: [],
      showMenu: false,
      x: 0,
      y: 0,
      invalid: false,
      store: {
        name: '',
      },
      error: null,
      imageHelpers,
      searchText: null,
      showCreateDialog: false,
    };
  },
  created() {
    this.auth();
    this.getUserInfo();
    this.getStores();
  },
  methods: {
    ...mapMutations(['setUser']),
    async createAllAfterCreateStore(storeId, defaultSystemDomain) {
      let [cartRecommend, moreCollection, bestSeller, recentView, alsoBought, handpickedProduct, pickForYou] = [
        {
          ...this.defaultConfig,
          widgetType: 'cartRecommend',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'Cart recommendations',
            },
            place: {
              cartPage: true,
              homePage: true,
              productPage: true,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'moreCollection',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'More from {{collection_name}}',
            },
            place: {
              cartPage: true,
              homePage: false,
              productPage: true,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'bestSeller',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'Store best sellers',
            },
            place: {
              homePage: true,
              cartPage: false,
              productPage: false,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'recentView',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'Recently viewed & featured recommendations',
            },
            place: {
              cartPage: true,
              homePage: true,
              productPage: true,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'alsoBought',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'Who bought this also bought',
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'handpickedProduct',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            place: {
              productPage: true,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
        {
          ...this.defaultConfig,
          widgetType: 'pickForYou',
          activated: false,
          widgetCustomize: {
            ...this.defaultConfig.widgetCustomize,
            header: {
              ...this.defaultConfig.widgetCustomize.header,
              textTitle: 'Pick For You',
            },
            showWith: 'sameTitle',
            place: {
              productPage: true,
              page: {
                collectionIds: [],
                productIds: [],
                selectType: 'products',
                isShowAtSpecificPage: false,
              },
            },
          },
        },
      ];
      //cartRecommend

      let res = await widgetApi.createAllAfterCreateStore(
        {
          productWidgets: [
            cartRecommend,
            moreCollection,
            bestSeller,
            recentView,
            alsoBought,
            handpickedProduct,
            pickForYou,
          ],
        },
        storeId,
        defaultSystemDomain,
      );
    },
    async getUserInfo() {
      try {
        this.isLoading = true;
        let data = await userService.get();
        if (data) {
          this.setUser(data.data);
          localStorage.removeItem('dropnoxe-user');
          localStorage.setItem('dropnoxe-user', JSON.stringify(data.data));
        }
      } catch (error) {
        console.log(error);
      }
    },
    /*
    Func show dropdown
    */
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    /*
    Fnc click and redirect to admin
    */
    async onClickShop(store) {
      window.localStorage.setItem(STORAGE_NAME.STORE_ID, store.id);
      window.localStorage.setItem(STORAGE_NAME.STORE_DOMAIN, store.storeDetail.defaultSystemDomain);
      let access_token = window.localStorage.getItem(STORAGE_NAME.ACCESS_TOKEN);
      let refresh_token = window.localStorage.getItem(STORAGE_NAME.REFRESH_TOKEN);
      // localStorage.clear();
      try {
        let data = await authService.checkSurvey({
          storeId: store.id,
          token: access_token,
        });
        console.log('🚀 ~ file: Shop.vue:406 ~ onClickShop ~ data:', data);
        if (data.status == 200) {
          setTimeout(() => {
            let baseUrl = store.storeDetail.primaryDomain || store.storeDetail.defaultSystemDomain;
            let url = 'https://' + baseUrl + '/admin/';
            if (window.location.href.includes('localhost')) {
              // For deverlopment
              url = `${window.location.origin}/admin/`;
            }

            window.location.href =
              url +
              '?access_token=' +
              access_token +
              '&refresh_token=' +
              refresh_token +
              '&system_domain=' +
              store.storeDetail.defaultSystemDomain +
              '&store_id=' +
              store.id +
              '&r_domain=' +
              (store.primaryDomain ? store.primaryDomain : store.storeDetail.defaultSystemDomain);
          }, 0);
        }
      } catch (error) {
        localStorage.setItem('defaultSystemDomain', store.storeDetail.defaultSystemDomain);
        this.$router.push({
          name: 'auth/survey',
          query: {
            register: store.storeDetail.name,
            storeId: store.id,
            defaultSystemDomain: store.storeDetail.defaultSystemDomain,
          },
        });
        console.log('🚀 ~ file: Shop.vue:408 ~ onClickShop ~ error:', error);
      }
    },
    /*
    Fnc get user stores
    */
    async getStores() {
      try {
        this.isLoading = true;
        let lastId = null;
        do {
          const { data } = await userService.getStores(lastId ? lastId : '');
          const newStores = data?.reverse()?.filter(store => store !== null) || [];
          this.stores = [...this.stores, ...newStores];
          lastId = newStores?.[0]?.lastId || null;
          this.isLoading = false;
          if (lastId) {
            await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 2 seconds before the next call
          }
        } while (lastId);
      } catch (error) {
        console.log('🚀 ~ getStores ~ error:', error);
      } finally {
        this.isLoading = false;
      }
    },
    /*
    Fnc logout
    */
    logout() {
      try {
        authService.logout();
        localStorage.clear();
        this.$router.push({ name: 'home' });
      } catch (error) {
        console.log(error.response);
      }
    },
    /*
    Fnc add store
    */
    async addStore() {
      this.$v.$touch();
      this.invalid = this.$v.$invalid;
      this.isLoadingButton = true;
      if (!this.$v.$invalid) {
        try {
          const codeRef = this.$store.state?.auth.codeRefCreateStore;
          let newStore = await userService.addStore(codeRef ? { ...this.store, code: codeRef } : this.store);
          await this.getStores();
          let storeId = newStore ? newStore.data.storeId : '';
          let findStore = this.stores.find(s => s.id === storeId);
          let defaultSystemDomain = findStore ? findStore.storeDetail.defaultSystemDomain : '';
          localStorage.setItem(STORAGE_NAME.STORE_DOMAIN, defaultSystemDomain);
          await this.addPayments(storeId);
          localStorage.setItem('store-id', storeId);
          localStorage.setItem('defaultSystemDomain', defaultSystemDomain);
          this.createAllAfterCreateStore(storeId, defaultSystemDomain);
          this.$store.commit('setMessages', {
            messages: 'Create store successfully!',
            type: 'success',
          });
          this.$router.push({
            name: 'auth/survey',
            query: { register: this.store.name, storeId: storeId, defaultSystemDomain: defaultSystemDomain },
          });
          this.store.name = '';
          // this.createAllWidget();
          this.$v.$reset();
          this.invalid = false;
          this.error = null;
          this.isLoadingButton = false;
        } catch (error) {
          this.error = error;
          this.isLoadingButton = false;
        }
      } else {
        this.isLoadingButton = false;
      }
    },

    async addPayments(storeId) {
      try {
        let payments = await storeService.addPayments(storeId);
        console.log('payments', payments);
      } catch (error) {
        console.log(error.response);
      }
    },
  },
  computed: {
    ...mapGetters(['user']),
    fullName() {
      if (!this.user?.firstName && !this.user?.lastName) return 'User';
      return (this.user.firstName ? this.user.firstName : '') + ' ' + (this.user.lastName ? this.user.lastName : '');
    },
    storesDisplay() {
      if (!this.searchText) return this.stores;
      return this.stores.filter(item =>
        item?.storeDetail?.defaultSystemDomain?.includes(this.searchText.toLowerCase()),
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-container {
  width: 100%;
  max-width: 380px;
  padding: 0 12px;
}
.store-image {
  width: 40px;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
.disabled-store {
  opacity: 0.5;
  &:hover {
    background-color: transparent !important;
  }
}
.report-btn {
  background: rgba(63, 81, 181, 0.08) !important;
  border-radius: 10px !important;
  transition: background 0.2s;
  &:hover {
    background: rgba(63, 81, 181, 0.18) !important;
  }
}
</style>
